import { Check } from "lucide-react";

const SidebarButton = ({
  label,
  activeStep,
  step,
  handleSidebarButtonClick,
  disabled,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={handleSidebarButtonClick}
      className={`flex text-slate-500 items-center justify-start p-4 w-[95%] m-auto font-semibold hover:bg-slate-100 whitespace-nowrap text-sm
      ${step === activeStep && "!text-blue-500 bg-blue-50"} rounded-xl`}
    >
      <div
        className={`${
          activeStep > step ? "w-4 h-4 p-0.5" : "w-2 h-2"
        } rounded-lg transition-all duration-200 mr-2 bg-slate-200 ${
          activeStep >= step && "!bg-blue-500"
        }`}
      >
        {activeStep > step && (
          <Check strokeWidth={4} size={12} color="#ffffff" />
        )}
      </div>
      {label}
    </button>
  );
};

export default SidebarButton;
